import { render, staticRenderFns } from "./CreateTerm.vue?vue&type=template&id=350bbaae"
import script from "./CreateTerm.vue?vue&type=script&lang=js"
export * from "./CreateTerm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports